<div class="mb-1 accounts-groups" fxLayout="column" fxLayoutAlign="center center">
    <mat-card fxFlex="0 1 90%" fxFlex.lt-md="100%" fxLayout="column wrap" class="kd-green-top">
        <div class="res-listing-wrapper user-gen-listing" fxLayout="column" fxFlex="0 0 100%">
            <app-table-toolbar class="toolbar" color="accent">
                <mat-accordion fxFlex="0 0 100%" displayMode="flat">
                    <mat-expansion-panel [expanded]="true" #expansionPanel>
                        <mat-expansion-panel-header> </mat-expansion-panel-header>
                        <ng-container [ngTemplateOutlet]="filtersParent"></ng-container>
                    </mat-expansion-panel>
                </mat-accordion>

                <mat-progress-bar
                    class="progress progress-table-loader"
                    *ngIf="(dataSource.status | async) === 'loading'"
                    mode="indeterminate"
                >
                </mat-progress-bar>
            </app-table-toolbar>

            <div *ngIf="showActionHeader" class="header-replace">
                <div class="hover-wrapper top" fxLayoutAlign="start center">
                    <ng-container [ngTemplateOutlet]="selectiveTableActionBtns"></ng-container>
                </div>
            </div>
            <div class="table-wrapper">
                <mat-table
                    #table
                    [dataSource]="dataSource"
                    matSortActive="created_at"
                    matSort
                    matSortDirection="desc"
                    [class.mobileView]="isMobile"
                    [class.showHeader]="showActionHeader"
                >
                    <ng-container matColumnDef="select">
                        <mat-header-cell *matHeaderCellDef>
                            <mat-checkbox
                                (click)="$event.stopPropagation()"
                                (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()"
                            >
                            </mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <mat-checkbox
                                (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(post) : null"
                                [checked]="selection.isSelected(post)"
                                [aria-label]="checkboxLabel(post)"
                            >
                            </mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="columns">
                        <mat-header-cell *matHeaderCellDef>
                            <div fxLayoutAlign="start center">
                                <span i18n="@@columns">Columns</span>
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let post" class="pr-0-m">
                            <app-image-view
                                [media_id]="post.media"
                                [proportional]="!isMobile"
                                [paddingBottom]="'58px'"
                            ></app-image-view>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="title">
                        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@headline">
                            Headline
                        </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <span [class.original]="allowActionRow">
                                <span *ngIf="!isMobile">{{ post.title }}</span>
                            </span>
                            <div *ngIf="isMobile" fxLayout="row">
                                <div class="mobile-img-wrapper">
                                    <app-image-view [media_id]="post.media" [proportional]="true"></app-image-view>
                                </div>
                                <div fxLayout="column">
                                    <span class="mobile-tite">{{ post.title }}</span>
                                    <span *ngIf="post.published_at">{{
                                        post.published_at | kdDateFormat : 'YYYY-MM-DD'
                                    }}</span>
                                </div>
                            </div>
                            <button
                                *ngIf="isMobile"
                                class="expand-btn"
                                mat-icon-button
                                (click)="expandedRow = expandedRow === post ? null : post"
                            >
                                <mat-icon>
                                    {{ expandedRow === post ? 'expand_less' : 'expand_more' }}
                                </mat-icon>
                            </button>
                            <div *ngIf="!isMobile" [class.hover]="allowActionRow">
                                <div class="hover-wrapper" fxLayoutAlign="space-between center">
                                    <ng-container
                                        [ngTemplateOutlet]="tableCellActionBtns"
                                        [ngTemplateOutletContext]="{ post: post }"
                                    ></ng-container>
                                    <!-- <button
                                        class="hover-tools-btn"
                                        *ngIf="!(shareLoading | async); else shareLoadTemp"
                                        mat-icon-button
                                        matTooltip="Share"
                                        i18n-matTooltip="@@share"
                                        (click)="shareService.openShareDialog(post, shareLoading)"
                                    >
                                        <mat-icon>share</mat-icon>
                                    </button> -->
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="published_at">
                        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@published">
                            Published
                        </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <span *ngIf="isMobile" class="mobile-label" i18n="@@published"> Published </span>
                            <span *ngIf="post.published_at">{{ post.published_at | kdDateFormat : 'YYYY-MM-DD' }}</span>
                            <span *ngIf="!post.published_at" i18n>Not published yet</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="created_at">
                        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@created"> Created </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <span *ngIf="isMobile" class="mobile-label" i18n="@@created"> Created </span>
                            <span>{{ post.created_at | kdDateFormat : 'YYYY-MM-DD' }}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="tags">
                        <mat-header-cell *matHeaderCellDef i18n="@@tags"> Tags </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <div class="posts-tags">
                                <div
                                    class="tag-item"
                                    (click)="$event.stopPropagation(); onTagClick(tag)"
                                    *ngFor="let tag of post.tags"
                                >
                                    <span>{{ tag.name }}</span>
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Status </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <span *ngIf="isMobile" class="mobile-label" i18n> Status </span>
                            <div
                                [matTooltip]="post.status?.label"
                                i18n-matTooltip
                                [ngStyle]="{ color: post.status?.color }"
                                fxLayout="start center"
                                fxLayoutGap="5px"
                            >
                                <mat-icon>
                                    {{ post.status?.icon }}
                                </mat-icon>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="language_id">
                        <mat-header-cell *matHeaderCellDef>
                            <div fxLayoutAlign="start center">
                                <span i18n="@@lang">Lang</span>
                            </div>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <span *ngIf="isMobile" class="mobile-label" i18n="@@lang">Lang</span>
                            <ng-container>
                                <app-language-selector
                                    [language_id]="post.language_id"
                                    fxFlex="0 0 auto"
                                ></app-language-selector>
                            </ng-container>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="visibility">
                        <mat-header-cell *matHeaderCellDef i18n>Visibility</mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <mat-slide-toggle
                                color="primary"
                                [checked]="post.visibility"
                                (change)="post.visibility = $event.checked; onVisibilityToggle(post)"
                                (click)="$event.stopPropagation()"
                            ></mat-slide-toggle>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="tools">
                        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@tools"> Tools </mat-header-cell>
                        <mat-cell *matCellDef="let post">
                            <ng-container
                                [ngTemplateOutlet]="tableCellActionBtns"
                                [ngTemplateOutletContext]="{ post: post }"
                            ></ng-container>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                    <mat-row
                        (click)="authUser?.canEdit(post) && onRowClick($event, post)"
                        *matRowDef="let post; columns: columns"
                        [class.res-expanded-row]="expandedRow === post"
                    ></mat-row>
                </mat-table>
            </div>
        </div>
        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
    </mat-card>
</div>
<ng-template #rowHover>
    <div fxFlex="0 0 100%" fxLayout="row" fxLayoutAlign="center" class="spinner-container">
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </div>
</ng-template>
<ng-template #tableCellActionBtns let-post="post">
    <button
        class="tools-btn"
        mat-icon-button
        [disabled]="!authUser.canEdit(post)"
        (click)="$event.stopPropagation(); authUser.canEdit(post) && edit(post)"
        matTooltip="Edit"
        i18n-matTooltip="@@edit"
    >
        <mat-icon class="material-icons-outlined">edit</mat-icon>
    </button>
    <ng-container *ngIf="customer$ | async; let customer">
        <button
            *ngIf="post && post.id"
            [disabled]="!authUser.hasRoleHigherThan('divisionadmin')"
            matTooltip="Specify which learners and groups who will have access."
            i18n-matTooltip
            class="tools-btn"
            mat-icon-button
            (click)="specify(customer, post)"
        >
            <mat-icon>manage_accounts</mat-icon>
        </button>
    </ng-container>
    <button
        *ngIf="!!post.downloads"
        mat-icon-button
        matTooltip="Click to download"
        (click)="$event.stopPropagation(); download(post)"
        i18n-matTooltip="@@clickToMakeDownload"
    >
        <mat-icon>save_alt</mat-icon>
    </button>
</ng-template>
<ng-template #selectiveTableActionBtns>
    <div fxLayoutGap="20px">
        <button
            mat-button
            matTooltip="Delete"
            (click)="$event.stopPropagation(); functionNotImpl()"
            i18n-matTooltip="@@delete"
        >
            <mat-icon>delete</mat-icon>
            <span i18n>Delete posts</span>
        </button>
    </div>
</ng-template>
<ng-template #filtersParent>
    <app-table-filter
        [cacheScope]="AppScope.POST"
        [filtersTogglesInOnBtn]="true"
        [inGlobalFilter]="true"
        color="accent"
        #filter
    >
        <app-table-search [inGlobalFilter]="true" class="align-space" searchFilterRef></app-table-search>
        <app-language-filter
            [inGlobalFilter]="true"
            #langFilter
            fxFlex="0 0 auto"
            fxLayout="row"
            langFilterRef
        ></app-language-filter>
        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space"
            label="Status"
            i18n-label
            [property]="{
                name: GlobalFilterProperty.STATUS,
                type: GlobalFilterPropertyType.STATUS_RESOURCE
            }"
            [options]="generalModelStatusSelectOptions"
            resourceStateFilterRef
        ></app-select-filter>
        <app-tag-chip-search-filter
            [inGlobalFilter]="true"
            [languageChange]="langFilter.filterChange"
            fxFlex="50%"
            fxFlex.lt-md="100%"
            fxLayoutAlign="start"
            tagsFilterRef
        ></app-tag-chip-search-filter>
    </app-table-filter>
</ng-template>
